import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import ErrorMessage from 'apis/ErrorMessage';
import { packageApi } from 'apis/package/packageApis';

/// 패키지 목록
export const usePackageList = () => {
  const { status, data, error, isFetching } = useQuery(
    ['packageList'],
    async () => await packageApi.read(),
  );
  return { status, data, error, isFetching };
};

/// 패키지 등록
export const usePackageRegister = (setVisible) => {
  const queryClient = useQueryClient();

  return useMutation(async (props: any) => await packageApi.register(props), {
    onMutate: (props) => {
      ('');
    },
    onSuccess: (data) => {
      setVisible(false);
      queryClient.invalidateQueries(['packageList']);
      message.success('패키지가 등록되었습니다', 1);
    },
    onError: (props) => (err: any, variables, context) => {
      if (err?.response) {
        ErrorMessage(err.response.status, err.response.data);
      }
    },
  });
};

/// 패키지 수정
export const usePackageUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation(async (props: any) => await packageApi.update(props), {
    onMutate: (props) => {
      ('');
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(['packageList']);
      message.success('패키지가 수정되었습니다', 1);
    },
    onError: (props) => (err: any, variables, context) => {
      if (err?.response) {
        ErrorMessage(err.response.status, err.response.data);
      }
    },
  });
};
/// 패키지 서버 정보 수정
export const usePackageServerUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (props: any) => await packageApi.serverUpdate(props),
    {
      onMutate: (props) => {
        ('');
      },
      onSuccess: (data) => {
        queryClient.invalidateQueries(['packageList']);
        message.success('서버 정보가 수정되었습니다', 1);
      },
      onError: (props) => (err: any, variables, context) => {
        if (err?.response) {
          ErrorMessage(err.response.status, err.response.data);
        }
      },
    },
  );
};
